<template>
  <li
    ref="menuItemRef"
    :class="['gfr-slide-menu-item', asTrigger && 'gfr-slide-menu-item--trigger', asChild ? 'group/child' : 'group']"
    data-state="close"
    @click.stop="asTrigger && trigger()"
  >
    <slot />
  </li>
</template>
<script lang="ts" setup>
defineProps({
  asTrigger: Boolean,
  asChild: Boolean
})
const menuItemRef = ref<HTMLElement>()
function trigger() {
  if (menuItemRef.value) {
    menuItemRef.value.dataset.state = menuItemRef.value.dataset.state === 'open' ? 'close' : 'open'
  }
}
</script>
